/* MUTE Quick-View — Phase 6.1 (2026-06-15)
   Listing-Schnellansicht ohne PDP-Wechsel. Self-styling, idempotent.
   Trigger: [data-mute-qv-trigger][data-mute-qv-handle] (Event-Delegation).
   Quelle: /products/{handle}.js  →  Modal (Bild, Titel, Preis, Varianten, ATC).
   ATC reused: /cart/add.js → dispatch 'mute:cart:refresh' (Badge) + 'mute:cart:added' (Toast) + Cart-Drawer.open().
   A11y: role=dialog, aria-modal, Focus-Trap, ESC/Backdrop-Close, Scroll-Lock, prefers-reduced-motion. */
(function () {
  'use strict';
  if (window.MuteQuickView) return;

  var STYLE_ID = 'mute-qv-style';
  var ROOT_ID = 'mute-qv-root';
  var lastTrigger = null;
  var current = null; // { product, variants, optionNames }

  function euro(cents) {
    try {
      return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function sizedImg(src) {
    if (!src) return '';
    var sep = src.indexOf('?') > -1 ? '&' : '?';
    return src + sep + 'width=600&height=600&crop=center';
  }

  function optName(opt) { return (opt && typeof opt === 'object') ? opt.name : opt; }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css =
      '#' + ROOT_ID + '{position:fixed;inset:0;z-index:2147482000;display:none;}' +
      '#' + ROOT_ID + '.is-open{display:block;}' +
      '.mute-qv__backdrop{position:absolute;inset:0;background:rgba(10,10,10,.55);opacity:0;transition:opacity 180ms ease;}' +
      '#' + ROOT_ID + '.is-open .mute-qv__backdrop{opacity:1;}' +
      '.mute-qv__dialog{position:absolute;left:50%;top:50%;transform:translate(-50%,-48%);' +
      'width:min(720px,calc(100vw - 24px));max-height:calc(100vh - 32px);overflow:auto;' +
      'background:var(--mute-bg-white,#FFFFFF);border:1px solid var(--mute-border-strong,#0A0A0A);' +
      'box-shadow:0 18px 60px rgba(0,0,0,.28);opacity:0;transition:opacity 180ms ease,transform 180ms ease;}' +
      '#' + ROOT_ID + '.is-open .mute-qv__dialog{opacity:1;transform:translate(-50%,-50%);}' +
      '.mute-qv__grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(min(260px,100%),1fr));gap:clamp(14px,3vw,24px);padding:clamp(14px,3vw,22px);}' +
      '.mute-qv__media{margin:0;}' +
      '.mute-qv__media img{display:block;width:100%;aspect-ratio:1/1;object-fit:cover;background:var(--mute-bg-warm,#FAF8F3);border:1px solid var(--mute-border,#E8E3D8);}' +
      '.mute-qv__body{display:flex;flex-direction:column;gap:clamp(8px,1.6vw,12px);min-width:0;}' +
      '.mute-qv__eyebrow{margin:0;font-family:var(--mute-font-mono,monospace);font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:var(--mute-text-meta,#595959);}' +
      '.mute-qv__title{margin:0;font-family:var(--mute-font-display,sans-serif);font-weight:800;line-height:1.12;font-size:clamp(20px,2.4vw,26px);color:var(--mute-text-primary,#0A0A0A);overflow-wrap:anywhere;}' +
      '.mute-qv__price{margin:0;font-family:var(--mute-font-body,sans-serif);font-size:clamp(16px,1.8vw,19px);font-weight:700;color:var(--mute-text-primary,#0A0A0A);}' +
      '.mute-qv__price-was{margin-left:8px;font-weight:400;font-size:.85em;color:var(--mute-text-meta,#595959);text-decoration:line-through;}' +
      '.mute-qv__opt{display:flex;flex-direction:column;gap:4px;}' +
      '.mute-qv__opt label{font-family:var(--mute-font-mono,monospace);font-size:12px;letter-spacing:.04em;color:var(--mute-text-body,#2E2E2E);}' +
      '.mute-qv__opt select{min-height:44px;padding:8px 10px;font-family:var(--mute-font-body,sans-serif);font-size:15px;' +
      'border:1px solid var(--mute-border-strong,#0A0A0A);background:var(--mute-bg-white,#FFFFFF);color:var(--mute-text-primary,#0A0A0A);border-radius:0;width:100%;}' +
      '.mute-qv__atc{min-height:48px;margin-top:4px;display:inline-flex;align-items:center;justify-content:center;gap:8px;cursor:pointer;' +
      'border:1px solid var(--mute-signal-red-text,#C8341A);background:var(--mute-signal-red-text,#C8341A);color:#fff;' +
      'font-family:var(--mute-font-mono,monospace);font-size:14px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;padding:0 16px;width:100%;transition:background 150ms ease;}' +
      '.mute-qv__atc:hover{background:#b22c14;border-color:#b22c14;}' +
      '.mute-qv__atc:focus-visible{outline:3px solid var(--mute-text-primary,#0A0A0A);outline-offset:2px;}' +
      '.mute-qv__atc[disabled]{background:var(--mute-text-meta,#595959);border-color:var(--mute-text-meta,#595959);cursor:not-allowed;opacity:.7;}' +
      '.mute-qv__atc.is-loading{opacity:.7;cursor:progress;}' +
      '.mute-qv__link{font-family:var(--mute-font-mono,monospace);font-size:13px;font-weight:700;letter-spacing:.03em;color:var(--mute-signal-red-text,#C8341A);text-decoration:none;align-self:flex-start;}' +
      '.mute-qv__link:hover{text-decoration:underline;}' +
      '.mute-qv__err{margin:0;font-family:var(--mute-font-body,sans-serif);font-size:13px;color:var(--mute-signal-red-text,#C8341A);min-height:1px;}' +
      '.mute-qv__close{position:absolute;top:6px;right:6px;z-index:2;min-width:44px;min-height:44px;display:inline-flex;align-items:center;justify-content:center;' +
      'border:0;background:transparent;color:var(--mute-text-primary,#0A0A0A);font-size:26px;line-height:1;cursor:pointer;font-family:inherit;}' +
      '.mute-qv__close:focus-visible{outline:3px solid var(--mute-signal-red-text,#C8341A);outline-offset:-2px;}' +
      '.mute-qv__spinner{padding:48px 16px;text-align:center;font-family:var(--mute-font-mono,monospace);font-size:13px;color:var(--mute-text-meta,#595959);letter-spacing:.06em;}' +
      '@media (prefers-reduced-motion: reduce){.mute-qv__backdrop,.mute-qv__dialog{transition:opacity 120ms ease;}.mute-qv__dialog{transform:translate(-50%,-50%);}}';
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent = css;
    document.head.appendChild(st);
  }

  function rootEl() {
    var r = document.getElementById(ROOT_ID);
    if (r) return r;
    r = document.createElement('div');
    r.id = ROOT_ID;
    r.innerHTML =
      '<div class="mute-qv__backdrop" data-mute-qv-close></div>' +
      '<div class="mute-qv__dialog" role="dialog" aria-modal="true" aria-labelledby="mute-qv-title" tabindex="-1">' +
      '<button type="button" class="mute-qv__close" data-mute-qv-close aria-label="Schließen">×</button>' +
      '<div class="mute-qv__content"></div>' +
      '</div>';
    (document.body || document.documentElement).appendChild(r);
    r.addEventListener('click', function (e) {
      if (e.target.closest('[data-mute-qv-close]')) close();
    });
    return r;
  }

  function optionValuesByIndex(variants, idx) {
    var seen = {}, out = [];
    variants.forEach(function (v) {
      var val = v.options[idx];
      if (val != null && !seen[val]) { seen[val] = 1; out.push(val); }
    });
    return out;
  }

  function selectedVariant() {
    if (!current) return null;
    var root = rootEl();
    var selects = root.querySelectorAll('.mute-qv__opt select');
    if (!selects.length) return current.variants[0];
    var chosen = [];
    selects.forEach(function (s) { chosen.push(s.value); });
    return current.variants.find(function (v) {
      for (var i = 0; i < chosen.length; i++) { if (v.options[i] !== chosen[i]) return false; }
      return true;
    }) || null;
  }

  function refreshState() {
    var root = rootEl();
    var v = selectedVariant();
    var priceEl = root.querySelector('.mute-qv__price');
    var atc = root.querySelector('.mute-qv__atc');
    var img = root.querySelector('.mute-qv__media img');
    if (priceEl) {
      if (v) {
        var html = euro(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<span class="mute-qv__price-was">' + euro(v.compare_at_price) + '</span>';
        }
        priceEl.innerHTML = html;
      }
    }
    if (v && v.featured_image && v.featured_image.src && img) {
      img.src = sizedImg(v.featured_image.src);
    }
    if (atc) {
      if (!v) { atc.disabled = true; atc.textContent = 'Auswahl unvollständig'; }
      else if (!v.available) { atc.disabled = true; atc.textContent = 'Ausverkauft'; }
      else { atc.disabled = false; atc.dataset.variantId = v.id; atc.textContent = 'In den Warenkorb'; }
    }
  }

  function renderProduct(p) {
    current = { product: p, variants: p.variants, optionNames: p.options || [] };
    var root = rootEl();
    var content = root.querySelector('.mute-qv__content');
    var img = (p.featured_image) ? String(p.featured_image) : '';
    var imgSrc = sizedImg(img);
    var isSingle = (p.variants.length === 1) ||
      (p.options.length === 1 && String(optName(p.options[0])).toLowerCase() === 'title');

    var optsHtml = '';
    if (!isSingle) {
      p.options.forEach(function (rawName, idx) {
        var name = optName(rawName);
        var vals = optionValuesByIndex(p.variants, idx);
        if (vals.length <= 1) return;
        var sid = 'mute-qv-opt-' + idx;
        var o = '<div class="mute-qv__opt"><label for="' + sid + '">' + escapeHtml(name) + '</label><select id="' + sid + '" data-opt-index="' + idx + '">';
        vals.forEach(function (val) { o += '<option value="' + escapeAttr(val) + '">' + escapeHtml(val) + '</option>'; });
        o += '</select></div>';
        optsHtml += o;
      });
    }

    content.innerHTML =
      '<div class="mute-qv__grid">' +
      '<figure class="mute-qv__media">' +
      (imgSrc ? '<img src="' + escapeAttr(imgSrc) + '" alt="' + escapeAttr(p.title) + '" width="600" height="600" decoding="async">' : '') +
      '</figure>' +
      '<div class="mute-qv__body">' +
      '<p class="mute-qv__eyebrow">Schnellansicht</p>' +
      '<h2 class="mute-qv__title" id="mute-qv-title">' + escapeHtml((p.title || '').split('|')[0].trim()) + '</h2>' +
      '<p class="mute-qv__price"></p>' +
      optsHtml +
      '<button type="button" class="mute-qv__atc">In den Warenkorb</button>' +
      '<p class="mute-qv__err" role="alert"></p>' +
      '<a class="mute-qv__link" href="' + escapeAttr(p.url) + '">Volle Produktdetails →</a>' +
      '</div></div>';

    content.querySelectorAll('.mute-qv__opt select').forEach(function (s) {
      s.addEventListener('change', refreshState);
    });
    content.querySelector('.mute-qv__atc').addEventListener('click', addToCart);
    refreshState();
  }

  function addToCart(e) {
    var btn = e.currentTarget;
    if (btn.disabled || btn.classList.contains('is-loading')) return;
    var v = selectedVariant();
    if (!v || !v.available) return;
    var errEl = rootEl().querySelector('.mute-qv__err');
    if (errEl) errEl.textContent = '';
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        btn.classList.remove('is-loading');
        document.dispatchEvent(new CustomEvent('mute:cart:refresh'));
        document.dispatchEvent(new CustomEvent('mute:cart:added'));
        close();
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') { drawer.open(); }
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        if (errEl) errEl.textContent = 'Hat nicht geklappt. Nochmal versuchen oder zur Produktseite.';
      });
  }

  function open(handle, trigger) {
    if (!handle) return;
    injectStyle();
    lastTrigger = trigger || null;
    var root = rootEl();
    var content = root.querySelector('.mute-qv__content');
    content.innerHTML = '<div class="mute-qv__spinner">Lade …</div>';
    root.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    var dlg = root.querySelector('.mute-qv__dialog');
    if (dlg) dlg.focus();
    fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('load'); return r.json(); })
      .then(function (p) { renderProduct(p); var d = root.querySelector('.mute-qv__dialog'); if (d) d.focus(); })
      .catch(function () {
        content.innerHTML = '<div class="mute-qv__spinner">Konnte nicht laden. <a class="mute-qv__link" href="/products/' + encodeURIComponent(handle) + '">Zur Produktseite →</a></div>';
      });
  }

  function close() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    current = null;
    if (lastTrigger && typeof lastTrigger.focus === 'function') { lastTrigger.focus(); }
    lastTrigger = null;
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var root = document.getElementById(ROOT_ID);
      if (!root || !root.classList.contains('is-open')) return;
      var f = root.querySelectorAll('button,select,a[href],input,[tabindex]:not([tabindex="-1"])');
      var list = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null || el === document.activeElement; });
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function escapeAttr(s) { return escapeHtml(s); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mute-qv-trigger]');
    if (!t) return;
    e.preventDefault();
    open(t.getAttribute('data-mute-qv-handle'), t);
  });

  window.MuteQuickView = { open: open, close: close };
})();
